export default __webpack_public_path__ + "static/media/bsim.8d784cf6.svg";